const NETWORK_DOMAIN = 'network'
const NETWORK_ACTION = {
  ADD_REQUEST: 'NETWORK_ADD_REQUEST',
  DELETE_REQUESTS: 'NETWORK_DELETE_REQUESTS',
  UPDATE_IS_ONLINE: 'NETWORK_UPDATE_IS_ONLINE',
  DELETE_IS_ONLINE: 'NETWORK_DELETE_IS_ONLINE',
  UPDATE_IS_CONNECTED: 'NETWORK_UPDATE_IS_CONNECTED',
  DELETE_IS_CONNECTED: 'NETWORK_DELETE_IS_CONNECTED',
  DELETE_FAILED_REQUESTS: 'NETWORK_DELETE_FAILED_REQUESTS',
  DELETE_SAVING_REQUESTS_STATUS: 'NETWORK_DELETE_SAVING_REQUESTS_STATUS',
  DELETE_SAVING_REQUESTS_MODELS_STATUS: 'NETWORK_DELETE_SAVING_REQUESTS_MODELS_STATUS',
  INCREMENT_RETRY_COUNT: 'NETWORK_INCREMENT_RETRY_COUNT'
}

const NETWORK_ENDPOINT = {
  HEALTHCHECK: '/healthz'
}

const NETWORK_KEY = {
  IS_ONLINE: 'isOnline',
  IS_CONNECTED: 'isConnected',
  REQUESTS: 'requests'
}

const NETWORK_PATH = {
  IS_ONLINE: `${NETWORK_DOMAIN}.${NETWORK_KEY.IS_ONLINE}`,
  IS_CONNECTED: `${NETWORK_DOMAIN}.${NETWORK_KEY.IS_CONNECTED}`,
  REQUESTS: `${NETWORK_DOMAIN}.${NETWORK_KEY.REQUESTS}`
}

const NETWORK_STATE = {
  [NETWORK_KEY.IS_ONLINE]: true,
  [NETWORK_KEY.IS_CONNECTED]: true,
  [NETWORK_KEY.REQUESTS]: []
}

export {
  NETWORK_DOMAIN,
  NETWORK_KEY,
  NETWORK_ACTION,
  NETWORK_ENDPOINT,
  NETWORK_PATH,
  NETWORK_STATE
}
